import { styled, Button } from "@mui/material";

export const DeleteButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: "50%",
  padding: "12px",
  boxShadow: theme.shadows[1],
  "&:hover": {
    backgroundColor: theme.palette.background.default,
  },
}));
